import React from "react";
import { AppRegistry } from "react-native-web";
import { ApolloProvider } from "@apollo/client";
import ApolloContext from "@tvg/utils/apolloContext";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { get } from "lodash";
import GridFooterEvents from "@tvg/gtm/src/modules/GridFooter";
import { TVGThemeProviderWeb, TvgConfProvider } from "@tvg/design-system";
import { FormationTokens } from "@tvg/design-system/web";

import ApolloClient from "./apolloClient/ApolloClient";
import configureStore from "./configureStore";
import App from "./pages";

const preloadedState = window.__HOME_PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle
window.homepageRendered = true;

const useRDAService = get(
  preloadedState,
  "capi.featureToggles.useRDAService",
  false
);

if (window.seoRendered) {
  delete window.__HOME_PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle
}

GridFooterEvents();

const store = configureStore(preloadedState);

const Main = () => {
  const apolloClient = ApolloClient.createClient(false);
  return (
    <ApolloProvider client={apolloClient}>
      <ApolloContext.Provider
        value={{
          fcpClient: apolloClient,
          rdaClient: ApolloClient.createClient(false, "rda", useRDAService)
        }}
      >
        <TvgConfProvider>
          <TVGThemeProviderWeb isFanduelTheme={false}>
            <FormationTokens />
            <Provider store={store}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </Provider>
          </TVGThemeProviderWeb>
        </TvgConfProvider>
      </ApolloContext.Provider>
    </ApolloProvider>
  );
};

const Render = () => {
  AppRegistry.registerComponent("App", () => Main);

  AppRegistry.runApplication("App", {
    initialProps: {},
    // @TODO check if we can improve the hydration
    // hydrate: true,
    rootTag: document.getElementById("home")
  });
};

export default Render();
